"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _validationSchema = _interopRequireDefault(require("../form/validationSchema"));
var _campos = _interopRequireDefault(require("../form/campos"));
var _axios = _interopRequireDefault(require("axios"));
var _httpStatusCodes = _interopRequireDefault(require("http-status-codes"));
var _core = require("@stt-componentes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CadastroPaciente = function CadastroPaciente(props) {
  var strings = props.strings,
    callback = props.callback,
    campos = props.campos,
    cadastrar = props.cadastrar,
    setCadastrar = props.setCadastrar,
    dados = props.dados,
    headers = props.headers,
    usarTipoContato = props.usarTipoContato;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mostrarAlerta = _useState4[0],
    setMostrarAlerta = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    tituloAlerta = _useState6[0],
    setTituloAlerta = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    mensagemAlerta = _useState8[0],
    setMensagemAlerta = _useState8[1];
  var schema = (0, _validationSchema["default"])(strings, campos, true);
  var UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;
  var handleCloseAlerta = function handleCloseAlerta() {
    setMostrarAlerta(false);
  };
  (0, _react.useEffect)(function () {
    var v = {
      nome: dados.nome || '',
      genero: null,
      dataNascimento: null,
      cpf: dados.cpf || '',
      cns: dados.cns || '',
      referencia: dados.referencia || '',
      logradouro: '',
      bairro: '',
      pais: null,
      uf: null,
      municipio: null,
      cep: '',
      tipoContato1: null,
      contato1: '',
      contato2: '',
      email: ''
    };
    setValues(v);
  }, [dados]);
  var handleClose = function handleClose() {
    setCadastrar(false);
  };
  var formRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.SttModal, {
    title: strings.cadastrarPaciente,
    open: cadastrar,
    outModalClose: handleClose,
    iconClose: handleClose,
    maxWidth: "md",
    fullWidth: true,
    children: /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
      innerRef: formRef,
      initialValues: values,
      validationSchema: schema,
      onSubmit: function onSubmit(data, _ref) {
        var setSubmitting = _ref.setSubmitting,
          resetForm = _ref.resetForm;
        var dadosPaciente = _objectSpread({}, data);
        if (dadosPaciente.cpf) {
          dadosPaciente.cpf = dadosPaciente.cpf.replace(/\D+/g, '');
        }
        if (dadosPaciente.cns) {
          dadosPaciente.cns = dadosPaciente.cns.replace(/\D+/g, '');
        }
        if (dadosPaciente.cep) {
          dadosPaciente.cep = dadosPaciente.cep.replace(/\D+/g, '');
        }
        _axios["default"].post("".concat(UTILITARIOS_API_BASE_URL, "/paciente"), dadosPaciente, {
          headers: headers
        }).then(function (response) {
          callback(response.data.data);
          resetForm();
          handleClose();
        })["catch"](function (err) {
          var tituloAlertaErro = '';
          var mensagemAlertaErro = '';
          var response = err.response;
          var msg = strings.erroGenerico;
          if (response) {
            if (response.status === _httpStatusCodes["default"].BAD_REQUEST) {
              var resposta = response.data;
              var arrMensagem = [];
              resposta.errors.forEach(function (error) {
                arrMensagem.push("- ".concat(error.message));
              });
              msg = arrMensagem.join('\n');
              tituloAlertaErro = resposta.message;
              mensagemAlertaErro = msg;
            } else {
              tituloAlertaErro = strings.erro;
              mensagemAlertaErro = msg;
            }
          } else {
            tituloAlertaErro = strings.erro;
            mensagemAlertaErro = msg;
          }
          setTituloAlerta(tituloAlertaErro);
          setMensagemAlerta(mensagemAlertaErro);
          setMostrarAlerta(true);
        })["finally"](function () {
          setSubmitting(false);
        });
      }
    }, function (_ref2) {
      var isSubmitting = _ref2.isSubmitting,
        errors = _ref2.errors,
        submitCount = _ref2.submitCount;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.SttLoading, {
        open: isSubmitting,
        text: strings.salvandoPaciente
      }), /*#__PURE__*/_react["default"].createElement(_campos["default"], {
        strings: strings,
        campos: campos,
        contextoCadastroBasico: true,
        pacientePadrao: false,
        headers: headers,
        usarTipoContato: usarTipoContato,
        dadosCadastroOriginal: {},
        errors: errors,
        submitCount: submitCount
      }));
    }),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
      variant: "contained",
      color: "primary",
      nomarginleft: "true",
      onClick: function onClick() {
        if (formRef.current) {
          formRef.current.handleSubmit();
        }
      }
    }, "Salvar"), /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
      variant: "outlined",
      color: "primary",
      onClick: handleClose
    }, "Cancelar"))
  }), /*#__PURE__*/_react["default"].createElement(_core.SttAlerta, {
    open: mostrarAlerta,
    title: tituloAlerta,
    message: mensagemAlerta,
    type: "error",
    options: [{
      title: strings.ok,
      onClick: handleCloseAlerta
    }],
    onClose: handleCloseAlerta
  }));
};
CadastroPaciente.propTypes = {
  callback: _propTypes["default"].func.isRequired,
  headers: _propTypes["default"].object.isRequired,
  usarTipoContato: _propTypes["default"].bool,
  campos: _propTypes["default"].array.isRequired,
  cadastrar: _propTypes["default"].bool.isRequired,
  setCadastrar: _propTypes["default"].func.isRequired,
  dados: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(CadastroPaciente);